import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AdvanceVectoringUserService } from "app/analytic/advance-vectoring-user.service";
import { AdvanceVectoringLoaderService } from "app/analytic/advance-vectoring-loader.service";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import * as moment from "moment";
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import { Subject } from "rxjs/internal/Subject";
import * as FileSaver from "file-saver";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { CryptoService } from "app/shared/utils/crypto.service";

interface UsageAnalytics {
  value: string;
  viewValue: string;
}
@Component({
  selector: "app-advance-vectoring-users-graph",
  templateUrl: "./advance-vectoring-users-graph.component.html",
  styleUrls: ["./advance-vectoring-users-graph.component.scss"],
})
export class AdvanceVectoringUsersGraphComponent implements OnInit, OnDestroy {
  //  ***************SG-4637 start  *******************

  usageType: any = "All";
  updateChart = false;
  graphAPIResponse: any;
  @Input() dateData$: Subject<any>;
  dateType: { type: string; from: string; to: string; count: number };
  sessionPlayedChartLabels: any[];
  sessionPlayedChartDatasets: { data: any; label: string }[];
  missionName: string;
  missionType: any;
  totalLessionsSessions = 7;
  usageAnalyticsSelectedValue: string = "All";

  @ViewChild(HighchartsComponent, { static: false }) highchartsComponent: HighchartsComponent;
  subSink: Subscription;
  subSink1: Subscription;

  startDate: any;
  endDate: any;
  dateInfo: any;
  appData: any;
  usageEramAnalytics: UsageAnalytics[] = [
    { viewValue: "All", value: "All" },
    { viewValue: "Average Missions Duration", value: "AvgMissionDuration" },
    { viewValue: "Total Missions Sessions", value: "TotalMissions" },
    { viewValue: "Total Cleared Missions", value: "ClearedMissions" },

    { viewValue: "Total Not Cleared Missions", value: "NotClearedMissions" },
    { viewValue: "Total Voice Commands", value: "VoiceCommands" },
    { viewValue: "Total Text Commands", value: "TextCommands" },
    { viewValue: "Total Separation Violations", value: "separationViolation" },
  ];
  userName: any;
  constructor(private service: AdvanceVectoringUserService, private route: ActivatedRoute, private crypto: CryptoService, public avLoader: AdvanceVectoringLoaderService) { }

  ngOnInit(): void {
    let missionData = localStorage.getItem("selectedApp");
    this.appData = JSON.parse(missionData);
    if (JSON.parse(missionData).title == "Advanced Vectoring") {
      this.userName = localStorage.getItem("nickName");
      this.missionName = JSON.parse(missionData).missionName;
      this.missionType = JSON.parse(missionData).missionType;
      this.dateInfo = JSON.parse(localStorage.getItem("dateRange"));
      this.subSink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
        if (next) {
          if (this.dateInfo) {
            next = this.dateInfo;
          }

          this.dateType = { type: "", from: "", to: "", count: 0 };
          this.dateType.type = next.type ? next.type.toLowerCase() : "day";
          this.dateType.from = next.from ? next.from : moment(new Date()).format("YYYY-MM-DD");
          this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, "days");
          this.dateType.count = next.count ? next.count : 30;
          this.startDate = moment(next.startDate).format("YYYY-MM-DD");
          this.endDate = moment(next.endDate).format("YYYY-MM-DD");
          // this.initialLoad();
          this.updateChart = false;
          this.getGraphDetails();
        }
      });
    }
  }

  async getGraphDetails() {
    try {
      const username = this.userName;

      let nameStr;
      if (this.crypto.isProbablyEncrypted(username)) {
        nameStr = username;
      } else {
        nameStr = await this.crypto.encryptData(username);
      }

      this.avLoader.set("graph", true);
      this.service.getGraphDetailsForBasicUsers(this.appData.id, this.usageType, this.dateType.type.toLowerCase(), this.startDate, this.endDate, nameStr).subscribe({
        next: (response) => {
          this.avLoader.set("graph", false);
          this.graphAPIResponse = response;
          this.getGraphConfiguration();
        },
        error: (err) => {
          this.avLoader.set("graph", false);
          console.error("Step 6: API call error:", err);
        },
      });
    } catch (error) {
      console.error("🔥 Error in getGraphDetails:", error);
    }
  }

  getGraphConfiguration() {
    if (this.dateType.type == "day") {
      this.dateType = { type: "Day", from: moment(new Date()).format("YYYY-MM-DD"), to: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"), count: 30 };

      this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.dateType);
    } else if (this.dateType.type == "month") {
      this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.dateType.from);
    } else if (this.dateType.type == "year") {
      this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.dateType.from);
    } else if (this.dateType.type == "range") {
      let selectedFromDate = this.startDate;
      let selectedEndDate = this.endDate;
      this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(selectedFromDate, selectedEndDate);
    }

    let AvgMissionDuration = this.graphAPIResponse[0].AvgMissionDuration ? this.graphAPIResponse[0].AvgMissionDuration.map((v) => Number(v)) : this.graphAPIResponse[0].AvgMissionDuration;
    let ClearedMissions = this.graphAPIResponse[0].ClearedMissions ? this.graphAPIResponse[0].ClearedMissions.map((v) => Number(v)) : this.graphAPIResponse[0].ClearedMissions;
    let NotClearedMissions = this.graphAPIResponse[0].NotClearedMissions ? this.graphAPIResponse[0].NotClearedMissions.map((v) => Number(v)) : this.graphAPIResponse[0].NotClearedMissions;
    let TextCommands = this.graphAPIResponse[0].TextCommands ? this.graphAPIResponse[0].TextCommands.map((v) => Number(v)) : this.graphAPIResponse[0].TextCommands;
    let TotalMissions = this.graphAPIResponse[0].TotalMissions ? this.graphAPIResponse[0].TotalMissions.map((v) => Number(v)) : this.graphAPIResponse[0].TotalMissions;
    let VoiceCommands = this.graphAPIResponse[0].VoiceCommands ? this.graphAPIResponse[0].VoiceCommands.map((v) => Number(v)) : this.graphAPIResponse[0].VoiceCommands;
    let separationViolation = this.graphAPIResponse[0].separationViolation ? this.graphAPIResponse[0].separationViolation.map((v) => Number(v)) : this.graphAPIResponse[0].separationViolation;

    this.sessionPlayedChartDatasets = [];

    if (this.usageType == "All" || this.usageType == "AvgMissionDuration") {
      this.sessionPlayedChartDatasets.push({ data: AvgMissionDuration, label: "Average Missions Duration" });
    }
    if (this.usageType == "All" || this.usageType == "TotalMissions") {
      this.sessionPlayedChartDatasets.push({ data: TotalMissions, label: "Total Missions Sessions" });
    }
    if (this.usageType == "All" || this.usageType == "ClearedMissions") {
      this.sessionPlayedChartDatasets.push({ data: ClearedMissions, label: "Total Cleared Missions" });
    }
    if (this.usageType == "All" || this.usageType == "NotClearedMissions") {
      this.sessionPlayedChartDatasets.push({ data: NotClearedMissions, label: "Total Not Cleared Missions" });
    }
    if (this.usageType == "All" || this.usageType == "VoiceCommands") {
      this.sessionPlayedChartDatasets.push({ data: VoiceCommands, label: "Total Voice Commands" });
    }
    if (this.usageType == "All" || this.usageType == "TextCommands") {
      this.sessionPlayedChartDatasets.push({ data: TextCommands, label: "Total Text Commands" });
    }
    if (this.usageType == "All" || this.usageType == "separationViolation") {
      this.sessionPlayedChartDatasets.push({ data: separationViolation, label: "Total Separation Violations" });
    }
    const timepointPlayed = this.graphAPIResponse?.[0]?.["Timepoint"];
    if (timepointPlayed) {
      if (this.dateType.type == "day") {
        this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
      } else if (this.dateType.type == "month") {
        this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
      } else if (this.dateType.type == "year") {
        this.sessionPlayedChartLabels = timepointPlayed;
      } else if (this.dateType.type == "range") {
        this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
      }
    }
    this.updateChart = true;
    this.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
    this.dateInfo = undefined;
  }

  updateChartData(label: string[], dataset: any) {
    this.highchartsComponent.updateChartData(label, dataset);
  }

  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i <= data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === "month" || data.type === "Month") {
        const selectedMonth = moment(date).subtract(i, "months");
        daysDate.push(moment(selectedMonth).format("MMM YYYY"));
      } else if (data.type === "year" || data.type === "Year") {
        var selectedYear = moment(date).subtract(i, "years");
        daysDate.push(moment(selectedYear).format("YYYY"));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format("ddd, MMM D"));
      }
    }
    return daysDate.reverse();
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, "months");
      months.push(moment(selectedMonth).format("MMM YYYY"));
    }
    return months.reverse();
  }

  getLastFiveYearsDefault(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, "years");
      years.push(moment(selectedYear).format("YYYY"));
    }
    return years.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }
  
  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1);
  
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      });
  }
  
  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, day, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1, day);
  
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
      });
  }

  async exportCsvData(usage) {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    this.service.downloadGraphdata(usage, this.dateType.type, this.appData.id, this.usageType, nameStr, this.startDate, this.endDate).subscribe((data: any) => {
      let dataObject: any = data;
      if (data.type === "application/zip") {
        var blob = new Blob([data], { type: data.type });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
      } else {
        var blob = new Blob([data], { type: "application/csv" });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
      }
    });
  }

  changeAnalytics(event) {
    this.usageType = event;
    this.updateChart = false;
    this.getGraphDetails();
  }
  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
    this.avLoader.set("graph", false);
  }
}
//  ***************SG-4637 end  *******************
